import { Grid, Typography, Container, Button, Link } from "@mui/material";
import React, { useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SonyPDWHD1500img from "../../assets/images/Sony-PDW-HD1500.jpeg"
import { IoStarSharp } from "react-icons/io5";
import { FaRegCircleDot } from "react-icons/fa6";
import AOS from 'aos';
import "aos/dist/aos.css"

const SonyPDWHD1500 = () => {
    useEffect(()=>{
        AOS.init({duration:2000});
        window.scrollTo(0, 0);
    }, [])
  return (
    <Grid>
    <div id="product">
      <Container>
        <div className="pro-inner">
          <Row>
            <Col xs="6">
              <div className="image">
                <img src={SonyPDWHD1500img} alt="" />
              </div>
            </Col>
            <Col xs="6">
              <div className="innerContent" >
                <h3 className="sec-head">Sony PDW-HD1500</h3>
                <p className="para">
                The Sony PDW-HD1500 is a half rack XDCAM HD recorder for Sony's line of optical disc-based cameras</p>
               
                <p className="price">Call Now</p>
               

                <div className="meta">
                  <div className="category">
                    in <strong>XDCAM</strong>
                  </div>
                  <div className="rating">
                    <IoStarSharp />
                    <IoStarSharp />
                    <IoStarSharp />
                    <IoStarSharp />
                    <IoStarSharp />
                  </div>
                </div>
                <Button className="theme-btn">
                  <Link href="/Enquiry" >Send Enquiry</Link>
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
    
    <div id="abt-text">
        <Container>
          <div className="headcontent">
            <Row>
            <Col xs="12">
                <div className="innerContent" data-aos="fade-right" >
                  <h3 className="sec-head">
                  Model Details
                  </h3>
                  <p className="para">
                  The Sony PDW-HD1500 is a half rack XDCAM HD recorder for Sony's line of optical disc-based cameras, including the PDW-700. Built upon blue laser technology, the XDCAM HD line of products takes advantage of non-linear workflow, while keeping the same tape-based archiving infrastructure that professionals are accustomed to</p>
                  
                 <p className="para">The Sony PDW-HD1500 is a half rack XDCAM HD recorder for Sony's line of optical disc-based cameras, including the PDW-700. Built upon blue laser technology, the XDCAM HD line of products takes advantage of non-linear workflow, while keeping the same tape-based archiving infrastructure that professionals are accustomed to</p>
                </div>
              </Col>
           
              
             
            </Row>
          </div>
        </Container>
      </div>

 
   
  




  </Grid>
  )
}

export default SonyPDWHD1500